import { ShortcutDetail } from "./types";

export const defaultShortcut = (): ShortcutDetail => {
  return {
    organizationId: "",

    name: "",
    description: "",
    priority: 1,
    url: "",
    imageUrl: "",
    isPublished: false,
  };
};
